// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1PgIi","content":"Consent_content__OFoxg","footer":"Consent_footer__Xacfu"};